export default {
  items: [],
  currentPage: 1,
  pageSize: 10,
  totalPages: 0
}
